class ProductPair extends HTMLElement {
	constructor() {
		super();
		this.init();
	}

	init () {
		const slider = $(this.querySelector('#ProductPairSlider'))
		if (slider) {
			slider.slick();
		}
		const accordion = $(this.querySelector('#ProductPairAccordion'))
		$("#ProductPairAccordion .accordion .content").hide();

		$('#ProductPairAccordion .header').on('click', (event) => {
			const itemIndex = parseInt($(event.target).attr("data-index"))
			slider.slick('slickGoTo', itemIndex)
		})

		$.fn.slideFadeToggle  = function(opacity = 'toggle', height = 'toggle', speed = 200, callback, easing) {
		  return this.animate({opacity: opacity, height: height}, speed, easing, callback);
		};

		const firstContent = $('#ProductPairAccordion .item:nth-child(1) .content');
		const firstItem = $('#ProductPairAccordion .item:nth-child(1)');
		$(firstContent).addClass('open');
		$(firstItem).addClass('open');
		$(firstContent).slideFadeToggle()

		slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			const prevItem = $('#ProductPairAccordion .item:has(.content.open)');
			const newItem = $('#ProductPairAccordion .item:nth-child(' + (nextSlide + 1) + ')');
			const prevContent = $('#ProductPairAccordion .item .content.open');
			const newContent = $('#ProductPairAccordion .item:nth-child(' + (nextSlide + 1) + ') .content');
			if (prevContent) {
				$(prevContent).each((index, item) => {
					$(prevItem).removeClass('open');
					$(item).removeClass('open');
					$(item).slideFadeToggle()
				})
			}
			if (newContent) {
				$(newItem).addClass('open');
				$(newContent).addClass('open');
				$(newContent).slideFadeToggle()
			}
		});
	}

}

customElements.define('product-pair', ProductPair);
